import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import { useEffect } from 'react'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

export default function BirthYearPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value') || ''
  const { isUpdate, postToReactNative } = useUpdateMode()

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const birthYear = formData.get('birthYear') as string

    const answer = {
      question_key: 'birth_year',
      question: "What's your year of birth?",
      answer_key: birthYear,
      answer: birthYear,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer('birth_year', answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.birthYear.heading"
      placeholder="pages.onboarding.birthYear.placeholder"
      description="pages.onboarding.birthYear.description"
      pattern="\d{4}"
      maxLength={4}
      onSubmit={onSubmit}
      inputName="birthYear"
      value={value}
    />
  )
}
